var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RestService } from "../RestService";
const URL = "/dayProgramSection";
export class DayProgramSectionApi extends RestService {
    create(dayProgram) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.post(URL, dayProgram, this.headers.multipart);
            return res.ok;
        });
    }
    update(dayProgram) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.put(URL, dayProgram, this.headers.multipart);
            return res.ok;
        });
    }
    delete(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${URL}/${id}`;
            const res = yield this.httpClient.delete(url);
            return res.ok;
        });
    }
}
//# sourceMappingURL=DayProgramSectionApi.js.map